module.exports = __webpack_public_path__ + "img/step_img1.fbc1c083.png";